import { ErrorMessage, Field, FieldProps } from "formik";
import { Input } from "../../styles/Inputs";
import TextError from "./TextError";

export const PhoneInputField = (props: any) => {
  const { label, name, placeHolder, ...rest } = props;
  return (
    <Field name={name}>
      {({ field, form }: FieldProps) => (
        <>
          <Input
            id={name}
            type="tel"
            placeHolder={placeHolder}
            {...rest}
            {...field}
            error={form.touched[name] && form.errors[name]}
          ></Input>
          <br></br>
          {form.errors[name] && form.touched[name] ? (
            <ErrorMessage component={TextError} name={name} />
          ) : null}
        </>
      )}
    </Field>
  );
};
